import { render, staticRenderFns } from "./product-avatar.vue?vue&type=template&id=e2479b84&scoped=true&"
import script from "./product-avatar.vue?vue&type=script&lang=ts&"
export * from "./product-avatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2479b84",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2479b84')) {
      api.createRecord('e2479b84', component.options)
    } else {
      api.reload('e2479b84', component.options)
    }
    module.hot.accept("./product-avatar.vue?vue&type=template&id=e2479b84&scoped=true&", function () {
      api.rerender('e2479b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/product-avatar.vue"
export default component.exports